/// <amd-module name="Environments/EnvironmentTraceabilityWorkItems/Common/WorkItemViewService" />
import { IWorkItemsViewData, IWorkItemsViewService } from "Environments/EnvironmentTraceabilityWorkItems/Common/WorkItemViewService.types";
import { IArtifactDetails, WorkItemRef, WorkItemType, IDataResult } from "Traceability/WorkItems/Types";
import { WorkItemTypesUtility } from "Traceability/WorkItems/WorkItemTypesUtility";
import * as StringUtils from "VSS/Core/Util/String";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import { Utilities } from "Traceability/Common/Utilities";

const workItemsDataProviderId = "ms.vss-environments-web.environment-traceability-workitems-data-provider";

export class WorkItemsViewService extends VssService implements IWorkItemsViewService {
    private _contributionService: IVssContributionService;
    private _data: IWorkItemsViewData;

    public get pageData(): IWorkItemsViewData {
        return this._data;
    }

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this._contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
        this._initializePageData();
    }

    public _serviceEnd(pageContext: IVssPageContext): void {
        super._serviceEnd(pageContext);
    }

    public getWorkItems = (artifactDetails: IArtifactDetails): Promise<IDataResult<WorkItemRef>> => {
        return  Promise.resolve({} as IDataResult<WorkItemRef>);;
    }

    public getWorkItemTypes(artifactDetails: IArtifactDetails): Promise<WorkItemType[]> {
        return WorkItemTypesUtility.getWorkItemTypes(this.pageContext, artifactDetails);
    }

    private _initializePageData() {
        let syncData  = this._contributionService.getData<IWorkItemsViewData>(workItemsDataProviderId); 
        if(!syncData) {
             this._updateWorkItemTab(); 
        } else {
            let pageData: IWorkItemsViewData = syncData as IWorkItemsViewData;
            if (!!pageData.primaryArtifactAlias) {
                // order by primaryArtifactAlias and then other artifacts
                (pageData.artifactsData || []).sort((a, b) => localeIgnoreCaseComparer(pageData.primaryArtifactAlias, a && a.artifactVersion && a.artifactVersion.alias) === 0 ? -1 : 1);
            }
            // fill the artifact url for 'view details'
            pageData.artifactsData = Utilities.fillArtifactVersionDisplayUri<WorkItemRef>(this.pageContext, pageData.artifactsData);
            Utilities.setPrimaryArtifactAliasName(pageData.primaryArtifactAlias);
    
            this._data = pageData;
        }
    }

    private _updateWorkItemTab = async (): Promise<void> => {
        const pageData = await (this._contributionService.getDataAsync<IWorkItemsViewData>(workItemsDataProviderId, undefined, true) || {}) as IWorkItemsViewData;
        if (!!pageData.primaryArtifactAlias) {
            // order by primaryArtifactAlias and then other artifacts
            (pageData.artifactsData || []).sort((a, b) => localeIgnoreCaseComparer(pageData.primaryArtifactAlias, a && a.artifactVersion && a.artifactVersion.alias) === 0 ? -1 : 1);
        }
        // fill the artifact url for 'view details'
        pageData.artifactsData = Utilities.fillArtifactVersionDisplayUri<WorkItemRef>(this.pageContext, pageData.artifactsData);
        Utilities.setPrimaryArtifactAliasName(pageData.primaryArtifactAlias);

        this._data = pageData;
    }
}

Services.add("IWorkItemsViewService", { serviceFactory: WorkItemsViewService });
